<template>
  <b-modal id="modal-search" hide-footer scrollable centered body-class="pt-0 pl-2 pr-1" class="modal-search">
    <template #modal-header="{ close }">
      <span class="titleHeader">{{ titleModal }}</span>
      <div class="button-modal-header d-flex flex-row">
        <b-button
          size="sm"
          class="buttonReset"
          variant="link"
          @click.prevent="onReset"
        >
          全クリア
        </b-button>
        <b-button
        variant="info"
          size="sm"
          @click.prevent="onSubmit"
          class="buttonSearch text-white"
        >
          検索
        </b-button>
        <b-button
          size="sm"
          class="buttonClose d-flex flex-row align-items-center"
          variant="link"
          @click="close()"
        >
          <i class="material-icons material-icons-outlined">close</i>
        </b-button>
      </div>
    </template>
    <template>
      <div v-for="(tLabel, key) in tableLabels" :key="key">
        <b-row class="d-flex align-items-center ml-2 mr-1" v-if="tLabel.displayFlag === 1">
          <b-col sm="4" class="d-flex pl-0 my-3 pr-2">
            <label for="input-default" class="lblItemName">
              {{ tLabel.itemName }}
            </label>
          </b-col>
          <b-col sm="8" class="px-0 my-3">
            <!-- INPUT TYPE TEXT -->
            <b-form-input
              type="search"
              @keydown.enter="onSubmit"
              v-if="tLabel.dataType === 0"
              v-model="localData[tLabel.isItemNo]"
            />
            <!-- INPUT TYPE NUMBER -->
            <div
              v-if="tLabel.dataType === 1"
              class="
                number-modal-body
                d-flex
                flex-row
                align-items-center
                justify-content-center
              "
            >
              <b-form-input
                type="number"
                v-if="tLabel.dataType === 1"
                onkeydown="return (event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 188 && event.keyCode !== 190 && event.keyCode !== 187)"
                @keydown.enter="onSubmit"
                v-model.number="localData[`before_${tLabel.isItemNo}`]"
              ></b-form-input>
              <label class="iconBetween">&#126;</label>
              <b-form-input
                type="number"
                onkeydown="return (event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 188 && event.keyCode !== 190 && event.keyCode !== 187)"
                @keydown.enter="onSubmit"
                v-if="tLabel.dataType === 1"
                v-model.number="localData[`after_${tLabel.isItemNo}`]"
              ></b-form-input>
            </div>
            <!-- INPUT TYPE LIST -->
            <div v-if="tLabel.dataType === 2">
              <form-select-component
                v-model="localData[tLabel.isItemNo]"
                :options="tLabel.mstGenCode.map(genCode => genCode.code)"
                :customLabel="opt => tLabel.mstGenCode.find(x => x.code === opt).name"
                :multiple="true"
                :searchable="true"
                :allowEmpty="true"
                :showLabels="true"
                placeholder="選択して検索"
                :hideSelected="true"
                :closeOnSelect="false"
              />
            </div>
            <!-- INPUT TYPE DATE -->
            <div v-if="tLabel.dataType === 3" class="date-picker">
              <date-picker
                v-model="localData[`before_${tLabel.isItemNo}`]"
                format="YYYY-MM-DD"
                value-type="format"
                class="dialogDateCalendar"
                ref="datepicker">
              </date-picker>
              <label class="iconBetween">&#126;</label>
              <date-picker
                v-model="localData[`after_${tLabel.isItemNo}`]"
                format="YYYY-MM-DD"
                value-type="format"
                class="dialogDateCalendar"
                ref="datepicker">
              </date-picker>
            </div>
          </b-col>
        </b-row>
        <hr v-if="tLabel.displayFlag === 1" class="my-0" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import AppConstants from '../../constants/app.constants'
import { FieldDataType } from '../../enums/field-data-type.enums'
import FormSelectComponent from './FormSelectComponent.vue'
const moment = require('moment')
export default {
  components: {
    DatePicker,
    FormSelectComponent
  },
  data() {
    return {
      // eslint-disable-next-line no-array-constructor
      sortValueKey: new Array(),
      limitData: {},
      localData: {},
      selected: []
    }
  },
  mounted() {
    this.initialize()
  },
  props: ['tableLabels', 'titleModal', 'tableNo', 'tableData', 'queryPrameterValue'],
  watch: {
    queryPrameterValue: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          (this.localData = { ...newValue })
        }
      },
      deep: true
    },
    tableLabels: function(newValue, oldValue) {
      if (newValue) {
        let oldValueTaskType = oldValue.find(item => item.isItemNo === 'taskType')
        let newValueTaskType = newValue.find(item => item.isItemNo === 'taskType')
        let listMstGenCodeOldValue = oldValueTaskType ? oldValueTaskType.mstGenCode.map(item => item.code) : []
        let listMstGenCodeNewValue = newValueTaskType ? newValueTaskType.mstGenCode.map(item => item.code) : []
        if (listMstGenCodeNewValue.length > listMstGenCodeOldValue.length && this.localData.taskType && this.localData.taskType.length === listMstGenCodeOldValue.length) {
          this.localData.taskType = listMstGenCodeNewValue
        } else if (this.localData.taskType) {
          this.localData.taskType = this.localData.taskType.filter(element => listMstGenCodeNewValue.includes(element))
        }
      }
    }
  },
  methods: {
    onSubmit() {
      for (let key in this.tableLabels) {
        let dataType = this.tableLabels[key]['dataType']
        let keyName = this.tableLabels[key]['isItemNo']
        if (dataType === FieldDataType.LIST) {
          if (
            this.localData[keyName].length ===
            this.tableLabels[key].mstGenCode.length
          ) {
            this.$set(this.localData, keyName, [])
          }
        } else if (dataType === FieldDataType.DATE) {
          const date = this.formatedDate(this.localData[keyName], AppConstants.APP_YEAR_MONTH_DATE_FORMAT_BY_DASH)
          this.$set(this.localData, keyName, date)
        }
      }
      this.$emit('search', this.localData, false, true)
      this.$bvModal.hide('modal-search')
    },
    showModal() {
      this.localData = { ...this.queryPrameterValue }
      for (let key in this.tableLabels) {
        let dataType = this.tableLabels[key]['dataType']
        let keyName = this.tableLabels[key]['isItemNo']
        let mstGenCode = this.tableLabels[key]['mstGenCode']
        if (dataType === FieldDataType.LIST) {
          if (!this.localData[keyName] || this.localData[keyName].length === 0) {
            let listCode = mstGenCode.map(e => e.code)
            this.localData[keyName] = [...listCode]
          }
        } else if (dataType === FieldDataType.DATE) {
          this.localData[keyName] = this.formatedDate(this.localData[keyName], AppConstants.APP_YEAR_MONTH_DATE_FORMAT)
        }
      }
      this.$bvModal.show('modal-search')
    },
    onReset() {
      for (let key in this.tableLabels) {
        let dataType = this.tableLabels[key]['dataType']
        let keyName = this.tableLabels[key]['isItemNo']
        let mstGenCode = this.tableLabels[key]['mstGenCode']
        switch (dataType) {
          case FieldDataType.STRING:
            this.$set(this.localData, `${keyName}`, null)
            break
          case FieldDataType.NUMBER:
            this.$set(this.localData, `before_${keyName}`, null)
            this.$set(this.localData, `after_${keyName}`, null)
            break
          case FieldDataType.LIST:
            if (mstGenCode.length) {
              this.$set(this.localData, keyName, mstGenCode.map(s => s.code))
            }
            break
          case FieldDataType.DATE:
            this.$set(this.localData, `before_${keyName}`, null)
            this.$set(this.localData, `after_${keyName}`, null)
            break
        }
      }
    },
    initialize(firstInit = true) {
      for (let key in this.tableLabels) {
        let dataType = this.tableLabels[key]['dataType']
        let keyName = this.tableLabels[key]['isItemNo']
        let mstGen = {}
        if (this.tableLabels[key].mstGenCode) {
          this.tableLabels[key].mstGenCode.forEach(gen => {
            mstGen[gen.code] = gen.name
          })
        }
        this.sortValueKey.push({
          dataType,
          keyName,
          mstGenLabel: mstGen
        })
        var routeQuery = this.$route.query[keyName]
        if (this.$route.query) {
          switch (dataType) {
            case FieldDataType.STRING:
              this.$set(this.localData, `${keyName}`, routeQuery || null)
              break
            case FieldDataType.NUMBER:
              let numberQuerys = routeQuery || []
              if (!Array.isArray(numberQuerys)) {
                numberQuerys = [numberQuerys]
              }
              this.$set(this.localData, `before_${keyName}`, numberQuerys[0] || null)
              this.$set(this.localData, `after_${keyName}`, numberQuerys[1] || null)
              break
            case FieldDataType.LIST:
              let listQuerys = routeQuery || []
              if (!Array.isArray(listQuerys)) {
                listQuerys = [listQuerys]
              }
              let result
              if (listQuerys) {
                result = listQuerys.map(function (x) {
                  return parseInt(x)
                })
              }
              this.$set(this.localData, keyName, result)
              break
            case FieldDataType.DATE:
              let dateQueryStrs = routeQuery || []
              if (!Array.isArray(dateQueryStrs)) {
                dateQueryStrs = [dateQueryStrs]
              }
              dateQueryStrs[0] = dateQueryStrs[0]
                ? dateQueryStrs[0].replace(' 00:00:00', '')
                : null
              dateQueryStrs[1] = dateQueryStrs[1]
                ? dateQueryStrs[1].replace(' 23:59:59', '')
                : null
              this.$set(
                this.queryPrameterValue,
                `before_${keyName}`,
                dateQueryStrs[0] || null
              )
              this.$set(
                this.queryPrameterValue,
                `after_${keyName}`,
                dateQueryStrs[1] || null
              )
              break
          }
        }
      }
    },
    formatedDate(dateString, typeFormat) {
      const date = Date.parse(dateString)
      if (date) {
        return moment(date).format(typeFormat)
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.button-modal-header {
  font-style: normal;
  font-weight: normal;
  line-height: 160%;
  .buttonSearch {
    margin: 0px 35px;
    white-space: nowrap;
    padding: 0 1.25em;
    min-width: 65px;
    min-height: 35px;
  }
  .buttonReset {
    color: $base_blue_light;
    &:hover {
      text-decoration: none;
    }
  }
}
.titleHeader {
  font-style: normal;
  font-weight: bold;
  @include responsive-fs(20);
}
#modal-action .row div[class^='col-sm'] {
  padding-left: 10px;
  padding-right: 10px;
}
.date-picker {
  display: flex;
  flex-direction: row;
}
.noDataTableLabels {
  text-align: center;
  color: $text_gray;
  opacity: 0.5;
}
.lblItemName {
  margin-bottom: 0px !important;
  word-break: break-word;
  @include responsive-fs(14);
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/SearchModalComponent.vue